/**
 * @description: 兼容ie10 及以下没有window.location.origin
 * @return {*}
 */
export function getOrigin() {
  // eslint-disable-next-line
  return window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
}

/**
 * @description: 是否PC环境
 * @return {boolean}
 */
export function isPCCheck() {
  const ua = navigator.userAgent.toLowerCase();
  const isPC = !/applewebkit.*mobile.*/.test(ua);
  return isPC;
}

// 是否为对象(下面的方法有依赖，勿删)
export function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
}

// 是否为空对象(下面的方法有依赖，勿删)
export function isEmptyObject(data) {
  try {
    return JSON.stringify(data) === '{}';
  } catch (e) {
    return false;
  }
}

/**
 * @description: 过滤表情包
 * @param {string} str
 * @return {string}
 */
export function removeEmoji(str = '') {
  if (!str) {
    return '';
  }
  // 使用正则表达式匹配表情符号
  const emojiRegex = /[\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g;

  // 替换表情符号为空字符串
  return str.replace(emojiRegex, '');
}

/**
 * @description: 过滤特殊字符
 * @param {string} str
 * @return {string}
 */
export function removeSpecialCharacters(str) {
  if (!str) {
    return '';
  }
  // 定义一个正则表达式，匹配指定的一组特殊字符
  // eslint-disable-next-line no-useless-escape
  const regex = /[!@#$%^&*()_\-={}\[\]?\/.,><]/g;
  // 使用正则表达式替换匹配的字符为空字符串
  return str.replace(regex, '');
}

function isInIframeFn() {
  return window.self !== window.top;
}

export const isInIframe = isInIframeFn();
